This activity will be used to determine if the renewable application is ready to
be reviewed from the list of pending registrations.
